import { createContext, useContext, useMemo, useState, type ReactNode } from 'react';
import { TitleParams } from '@/routing/document-title/types';

type TitleContextValue = {
  params: TitleParams;
  setTitleParams: (params: TitleParams) => void;
};

const TitleContext = createContext<TitleContextValue>({
  params: {},
  setTitleParams: () => {},
});

export const useTitleParams = () => useContext(TitleContext);

export const TitleProvider = ({ children }: { children: ReactNode }) => {
  const [params, setTitleParams] = useState<TitleParams>({});

  const value = useMemo(() => ({ params, setTitleParams }), [params]);

  return <TitleContext.Provider value={value}>{children}</TitleContext.Provider>;
};
